/* Project Import will be here */
import * as actions from '../actions/date.Action';
/* Project Import will be here */

/* Const,Let & Var will be here */
let initialState = {
    date: {
        selectedDate:new Date(),
        lastActivityDateTime: ''
    }
};

/* Const,Let & Var will be here */

export default function (state = initialState, action) {
    switch (action.type) {
        case actions.DATE_SELECTION:
            return {
                ...state,
                date: {
                    ...state.date,                  
                    selectedDate: action.selectedDate
                }
            };        
        case actions.LAST_ACTIVITY_DATE_TIME:
            return {
                ...state,
                date: {
                    ...state.date,                  
                    lastActivityDateTime: action.lastActivityDateTime
                }
            };        

        default:
            return state;
    }
}